import PropTypes from 'prop-types';
// material
import { Box, Stack, Tooltip, Typography } from '@mui/material';

import { Icon } from '@iconify/react';
// mdi:airplane-takeoff
import airplaneTakeoff from '@iconify/icons-mdi/airplane-takeoff';
// mdi:airplane-landing
import airplaneLanding from '@iconify/icons-mdi/airplane-landing';
// mdi:arrow-right
import arrowRight from '@iconify/icons-mdi/arrow-right';
// mdi:map-marker-distance
import mapMarkerDistanceIcon from '@iconify/icons-mdi/map-marker-distance';
// mdi:speedometer
import speedometer from '@iconify/icons-mdi/speedometer';
// mdi:image-filter-hdr
import imageFilterHdr from '@iconify/icons-mdi/image-filter-hdr';
// mdi:pinwheel-outline
import pinwheelOutline from '@iconify/icons-mdi/pinwheel-outline';
// mdi:airplane-clock
import airplaneClock from '@iconify/icons-mdi/airplane-clock';

import { useSelector } from 'react-redux';
import {
  distanceConverter,
  altitudeConverter,
  speedConverter
} from '../../common/utils/unitConverter';
import FlightReviewAeroTimeline from './FlighReviewAeroTimeline';
import { useTranslation } from '../../common/LocalizationProvider';
import { selectSession } from '../../createSelectorUtils';
// utils

FlightReviewInfo.propTypes = {
  reportTrip: PropTypes.object,
  positions: PropTypes.array,
  analyse: PropTypes.object
};
export default function FlightReviewInfo({ reportTrip, positions, analyse }) {
  const t = useTranslation();
  const session = useSelector(selectSession);
  return (
    <Box sx={{ mt: 2, ml: 1 }}>
      {reportTrip && reportTrip.driverName !== null && (
        <Typography variant="subtitle1">{`${t('fields_Pilot')}: ${
          reportTrip.driverName
        }`}</Typography>
      )}
      {reportTrip && reportTrip.instructeurName !== null && (
        <Typography variant="subtitle1">{`${t('fields_Instructor')}: ${
          reportTrip.instructeurName
        }`}</Typography>
      )}
      <Stack spacing={3} alignItems="center" sx={{ mt: 2 }}>
        <Stack direction="row" spacing={3}>
          <Tooltip title={t('FR_Details_ADDepart')}>
            <Stack direction="column" alignItems="center">
              <Icon icon={airplaneTakeoff} width={24} height={24} />
              <Typography variant="subtitle1">
                {(reportTrip && reportTrip.oaciAeroStart) || ''}
              </Typography>
            </Stack>
          </Tooltip>
          <Icon icon={arrowRight} width={24} height={24} />
          <Tooltip title={t('FR_Details_ADArrivée')}>
            <Stack direction="column" alignItems="center">
              <Icon icon={airplaneLanding} width={24} height={24} />
              <Typography variant="subtitle1">
                {(reportTrip && reportTrip.oaciAeroEnd) || ''}
              </Typography>
            </Stack>
          </Tooltip>
        </Stack>

        <FlightReviewAeroTimeline analyse={analyse} reportTrip={reportTrip} />

        <Stack direction="row" spacing={{ xs: 2, sm: 3, md: 2, lg: 2, xl: 3 }}>
          <Tooltip title={t('DB_Distance')}>
            <Stack direction="column" alignItems="center">
              <Icon icon={mapMarkerDistanceIcon} width={24} height={24} />
              <Typography variant="subtitle2">{`${
                reportTrip
                  ? distanceConverter(reportTrip.distance / 1000, session.uniteDistance)
                  : ''
              } ${session.uniteDistance === 'mille' ? 'NM' : session.uniteDistance}`}</Typography>
            </Stack>
          </Tooltip>
          <Tooltip title={t('FR_Details_EngineRuntime')}>
            <Stack direction="column" alignItems="center">
              <Icon icon={pinwheelOutline} width={24} height={24} />
              <Typography variant="subtitle2">{`${
                reportTrip ? Math.round(reportTrip.duration / 60000) : ''
              } min`}</Typography>
            </Stack>
          </Tooltip>
          <Tooltip title={t('FR_Details_MovementTime')}>
            <Stack direction="column" alignItems="center">
              <Icon icon={airplaneClock} width={24} height={24} />
              <Typography variant="subtitle2">{`${
                reportTrip ? Math.round(reportTrip.durationVol / 60000) : ''
              } min`}</Typography>
            </Stack>
          </Tooltip>
          <Tooltip title={t('FR_Details_AltitudeMax')}>
            <Stack direction="column" alignItems="center">
              <Icon icon={imageFilterHdr} width={24} height={24} />
              <Typography variant="subtitle2">{`${altitudeConverter(
                Math.max(...positions.map((o) => o.altitude)),
                session.uniteAltitude
              )} ${session.uniteAltitude}`}</Typography>
            </Stack>
          </Tooltip>

          <Tooltip title={t('FR_Details_SpeedMax')}>
            <Stack direction="column" alignItems="center">
              <Icon icon={speedometer} width={24} height={24} />
              <Typography variant="subtitle2">{`${
                reportTrip ? speedConverter(reportTrip.maxSpeed, session.uniteVitesse) : ''
              } ${session.uniteVitesse}`}</Typography>
            </Stack>
          </Tooltip>
        </Stack>
      </Stack>
    </Box>
  );
}
